module.exports = __webpack_public_path__ + "static/media/Subscription 3.009ac905.svg";